import React from 'react';
import Divider from 'components/Divider';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { positions } from 'constants/DropdownsValues';
import styles from './UserInfo.scss';// to import local scss fle


const UserInfo = props => (
  <div className={cn('row', styles.userInfoContainer)}>
    <div className={cn('col s12', styles.dataBox)}>
      <span className={styles.mainHeader}>MY BIOMETERIC INFO</span>
      <Divider />
      <div className={cn('col s12', styles.removePadding)} >
        <div className={cn('col s4')}>
          <span className={styles.blackHeader}> HEIGHT</span><br />
          <span className={styles.otherText}>{props.height}</span>
        </div>
        <div className={cn('col s4')}>
          <span className={styles.blackHeader}> WEIGHT</span><br />
          <span className={styles.otherText}>{props.weight}</span>
        </div>
        <div className={cn('col s4')}>
          <span className={styles.blackHeader}> BENCH MAX</span><br />
          <span className={styles.position}> {props.bench}</span>
        </div>
        <div className={cn('col s4')}>
          <span className={styles.blackHeader}> SQUATS MAX</span><br />
          <span className={styles.position}> { props.squats }</span>
        </div>
        <div className={cn('col s6')}>
          <span className={styles.blackHeader}> 40-YARD DASH</span><br />
          <span className={styles.position}> {props.t40}</span>
        </div>
      </div>
    </div>
    <div className={cn('col s12', styles.dataBox)}>
      <span className={styles.mainHeader}>MY SPORT INFO</span>
      <Divider />
      <div className={cn('col s12', styles.removePadding)}>
        <div className={cn('col 2')}>
          <img className={styles.icon} src="https://media.dev.myrecruitboard.com/Images/defaultFootball.png" alt="footballIcon" />
        </div>
        <div className={cn('col s4')}>
          <span className={styles.gameName}>{props.sportName}</span><br />
        </div>
      </div>
      <div className={cn('col s12', styles.removePaddingReplica)}>
        <div className={cn('col 12')}>
          <span className={styles.blackHeader}>POSITIONS</span><br />
          {(props.primary_offensive_position_pref !== '') || (props.secondary_offensive_position_pref) ?
            <div className={cn('col s12', styles.removePaddingReplica)}>
              <div className={cn('col s4', styles.attackType)}>
                <span className={styles.positionHeader}>OFFENSIVE: &nbsp;</span>
              </div>
              <div className={cn('col s8', styles.position)}>
                {positions[props.primary_offensive_position_pref]} <br />
                {positions[props.secondary_offensive_position_pref]}
              </div>
            </div> : '' }
          {props.primary_defensive_position_pref || props.secondary_defensive_position_pref ?
            <div className={cn('col s12', styles.removePaddingReplica)}>
              <div className={cn('col s4', styles.attackType)}>
                <span className={styles.positionHeader}>DEFENSIVE: &nbsp;</span>
              </div>
              <div className={cn('col s8', styles.position)}>
                {positions[props.primary_defensive_position_pref]} <br />
                {positions[props.secondary_defensive_position_pref]}
              </div>
            </div> : '' }
          {props.special_teams ?
            <div className={cn('col s12', styles.removePaddingReplica)}>
              <div className={cn('col s4', styles.attackType)}>
                <span className={styles.positionHeader}>SPECIAL TEAMS: &nbsp;</span>
              </div>
              <div className={cn('col s8', styles.position)}>
                {positions[props.special_teams]} <br />
              </div>
            </div> : '' }
        </div>
      </div>
    </div>
    <div className={cn('col s12', styles.dataBox)}>
      <span className={styles.mainHeader}>MY ACADEMIC BOARD</span>
      <Divider />
      <div className={cn('col s12', styles.removePadding)} >
        <div className={cn('col 2')}>
          <img className={styles.icon} src="https://media.dev.myrecruitboard.com/Images/defaultCollege.png" alt="footballIcon" />
        </div>
        <div className={cn('col s10')}>
          <span className={styles.gameName}>{props.school}</span><br />
          <span className={styles.position}> Year of Graduation - {props.year_of_graduation}</span>
        </div>
        <div className={cn('col s4 m4', styles.topSpace)}>
          <span className={styles.blackHeader}> GPA</span><br />
          <span className={styles.position}> {props.gpa}</span>
        </div>
        {props.sat !== '' ?
          <div className={cn('col s4 m4', styles.topSpace)}>
            <span className={styles.blackHeader}> SAT</span><br />
            <span className={styles.position}> {props.sat}</span>
          </div> : ''}
        {props.act !== '' ?
          <div className={cn('col s4 m4', styles.topSpace)}>
            <span className={styles.blackHeader}> ACT </span><br />
            <span className={styles.position}> { props.act }</span>
          </div> : ''}
      </div>
    </div>
  </div>
);

UserInfo.propTypes = {
  height: PropTypes.string.isRequired,
  weight: PropTypes.string.isRequired,
  sportName: PropTypes.string.isRequired,
  t40: PropTypes.string.isRequired,
  bench: PropTypes.string.isRequired,
  squats: PropTypes.string.isRequired,
  school: PropTypes.string.isRequired,
  year_of_graduation: PropTypes.string.isRequired,
  gpa: PropTypes.string.isRequired,
  sat: PropTypes.string.isRequired,
  act: PropTypes.string.isRequired,
  primary_offensive_position_pref: PropTypes.string.isRequired,
  primary_defensive_position_pref: PropTypes.string.isRequired,
  secondary_offensive_position_pref: PropTypes.string.isRequired,
  secondary_defensive_position_pref: PropTypes.string.isRequired,
  special_teams: PropTypes.string.isRequired,
};

export default UserInfo;



// WEBPACK FOOTER //
// ./src/components/UserInfo/UserInfo.js